import { useTeamMemberContacts } from "src/recoil/hooks/screens/contact/useTeamMemberContacts"

export const useContactAttendanceAnswerOverviewData = (contactId: string) => {
  const { attendanceAnswerOverview, isLoading } = useTeamMemberContacts(contactId)
  return { attendanceAnswerOverview, isLoading }
}
